/* eslint-disable */
import React, { useState, useEffect } from "react";

import CircularLoading from "components/CircularLoading";
import { useSelector } from "react-redux";

import { makeStyles } from "@material-ui/core";
import { useNavigate } from "react-router-dom";
import FlatList from "flatlist-react";

import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  FormGroup,
  Row,
  Col,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";
import classnames from "classnames";

const ConfirmedBooking = () => {
  const auth = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const bookinglistdata = useSelector((state) => state.bookinglistdata);

  const [role, setRole] = useState(null);
  const [baseData, setBaseData] = useState([]);
  const [oncoming, setOncoming] = useState([]);
  const [today, setToday] = useState([]);
  const [expired, setExpired] = useState([]);
  const [activeTab, setActiveTab] = useState("1");

  const useStyles = makeStyles(() => ({
    root: {
      minWidth: 275,
      borderRight: "4px solid",
      borderRadius: 8,
      padding: 0,
    },
  }));
  const classes = useStyles();

  const isSameDay = (timeA, timeB) => {
    const a = new Date(timeA);
    const b = new Date(timeB);
    return (
      a.getFullYear() === b.getFullYear() &&
      a.getMonth() === b.getMonth() &&
      a.getDate() === b.getDate()
    );
  };

  useEffect(() => {
    if (!bookinglistdata?.bookings) {
      setBaseData([]);
      return;
    }
    if (auth?.info?.profile?.userType === "patient") {
      setBaseData(
        bookinglistdata.bookings.filter(
          (b) =>
            b.patient === auth.info.uid &&
            (b.status === "ACCEPTED" || b.status === "COMPLETED")
        )
      );
    } else {
      setBaseData(bookinglistdata.bookings.filter((b) => b.status === "NEW"));
    }
  }, [bookinglistdata.bookings, auth?.info?.profile?.userType, auth?.info?.uid]);

  useEffect(() => {
    if (auth?.info?.profile) {
      setRole(auth.info.profile.userType);
    }
  }, [auth.info]);

  useEffect(() => {
    if (!baseData) {
      setOncoming([]);
      setToday([]);
      setExpired([]);
      return;
    }

    const now = Date.now();
    const GRACE = 30 * 60 * 1000;

    const on = [];
    const td = [];
    const ex = [];

    baseData.forEach((booking) => {
      const timeStr = booking.adjustedtimeStart || booking.eventDate;
      if (!timeStr) {
        ex.push(booking);
        return;
      }

      const startMs = new Date(timeStr).getTime();
      const endMs = booking.endDate
        ? new Date(booking.endDate).getTime()
        : startMs;

      if (isNaN(startMs)) {
        ex.push(booking);
        return;
      }

      if (now > endMs + GRACE) {
        ex.push(booking);
        return;
      }

      if (isSameDay(startMs, now)) {
        td.push(booking);
        return;
      }

      if (startMs > now) {
        on.push(booking);
        return;
      }

      ex.push(booking);
    });

    on.sort((a, b) => {
      const aMs = new Date(a.adjustedtimeStart || a.eventDate).getTime();
      const bMs = new Date(b.adjustedtimeStart || b.eventDate).getTime();
      return aMs - bMs;
    });

    setOncoming(on);
    setToday(td);
    setExpired(ex);
  }, [baseData]);

  const renderBooking = (Booking, index, section) => {
    const borderColors = {
      oncoming: "#007bff",
      today: "#28a745",
      expired: "#6c757d",
    };
    const borderColor = borderColors[section] || "#ff0000";

    return (
      <Col md="4" key={index}>
        {Booking.doctor ? (
          <Card className={classes.root} style={{ borderRightColor: borderColor }}>
            <CardHeader as="h5">
              <CardTitle tag="h4">
                <div className="picture">
                  <img
                    alt="..."
                    className="picturesrc"
                    src={Booking?.doctor?.profile_image}
                  />{" "}
                </div>
                {Booking?.doctor?.desc}
              </CardTitle>
            </CardHeader>
            <CardBody>
              <Row mb="12">
                <Col md="12">
                  <FormGroup>
                    <span>Type of Booking Service: </span>
                    <p className="description">{Booking.serviceType}</p>
                  </FormGroup>
                </Col>
                {Booking.adjustedtimeStart ? (
                  <Col>
                    <FormGroup>
                      <span>New Booking Date and Time: </span>
                      <p className="description">{Booking.adjustedtimeStart}</p>
                    </FormGroup>
                  </Col>
                ) : (
                  <Col>
                    <FormGroup>
                      <span>Date and Time of Booking: </span>
                      <p className="description">{Booking.eventDate}</p>
                    </FormGroup>
                  </Col>
                )}
              </Row>
              <Row mb="12">
                <Col md="12">
                  <FormGroup>
                    <span>Booking Status: </span>
                    <p className="description">{Booking.status}</p>
                  </FormGroup>
                </Col>
              </Row>
            </CardBody>
          </Card>
        ) : null}
      </Col>
    );
  };

  if (bookinglistdata?.loading) return <CircularLoading />;

  return (
    <Row>
      <Col md="12">
        <Card>
          <CardHeader>
            <CardTitle tag="h4">CONFIRMED BOOKINGS</CardTitle>
            <Nav tabs style={{ marginTop: 8 }}>
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === "1" })}
                  onClick={() => setActiveTab("1")}
                >
                  Oncoming ({oncoming.length})
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === "2" })}
                  onClick={() => setActiveTab("2")}
                >
                  Today ({today.length})
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === "3" })}
                  onClick={() => setActiveTab("3")}
                >
                  Expired ({expired.length})
                </NavLink>
              </NavItem>
            </Nav>
          </CardHeader>

          <CardBody>
            <TabContent activeTab={activeTab}>
              <TabPane tabId="1">
                <Row>
                  <FlatList
                    list={oncoming}
                    renderItem={(item, i) => renderBooking(item, i, "oncoming")}
                    renderWhenEmpty={() => <div>No oncoming bookings found.</div>}
                  />
                </Row>
              </TabPane>

              <TabPane tabId="2">
                <Row>
                  <FlatList
                    list={today}
                    renderItem={(item, i) => renderBooking(item, i, "today")}
                    renderWhenEmpty={() => <div>No bookings for today.</div>}
                  />
                </Row>
              </TabPane>

              <TabPane tabId="3">
                <Row>
                  <FlatList
                    list={expired}
                    renderItem={(item, i) => renderBooking(item, i, "expired")}
                    renderWhenEmpty={() => <div>No expired bookings found.</div>}
                  />
                </Row>
              </TabPane>
            </TabContent>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};

export default ConfirmedBooking;
